import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["showSuccessAlert", "onSuccess"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import { setAlert, setSuccessAlert } from 'actions/alerts';
function useUpdateMyFeedback(_ref) {
  var _ref$showSuccessAlert = _ref.showSuccessAlert,
    showSuccessAlert = _ref$showSuccessAlert === void 0 ? false : _ref$showSuccessAlert,
    _onSuccess = _ref.onSuccess,
    options = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  function updateMyFeedback(_x) {
    return _updateMyFeedback.apply(this, arguments);
  }
  function _updateMyFeedback() {
    _updateMyFeedback = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var id, rating, comment;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            id = _ref2.id, rating = _ref2.rating, comment = _ref2.comment;
            return _context.abrupt("return", api('patch', "/api/me/feedback/".concat(id), null, {
              rating: rating,
              comment: comment
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _updateMyFeedback.apply(this, arguments);
  }
  var _useMutation = useMutation(updateMyFeedback, _objectSpread(_objectSpread({}, options), {}, {
      onSuccess: function onSuccess() {
        _onSuccess === null || _onSuccess === void 0 ? void 0 : _onSuccess();
        if (showSuccessAlert) {
          setSuccessAlert({
            title: t('alert_feedback_updated_success')
          });
        }
      },
      onError: function onError() {
        setAlert({
          title: t('alert_feedback_updated_error')
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    updateMyFeedback: mutateAsync
  });
}
export default useUpdateMyFeedback;